// this file added by Bearer Web Developer
export const validateLatestDate = (value: string) => {
    if (value.length === 0) return "Latest date is required";
}
export const validateLatestTime = (value: string) => {
    if (value.length === 0) return "Latest time is required";
}

